<template>
  <div class="m-0 dbozone-font">
    <div class="col-12 justify-content-center d-flex flex-row header-blessingox">
      <div class="px-3 col-3 p-0">
        <div class="heading-blessingox">{{ $t('result.round') }}</div>
        <div class="text-subhead">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-blessingox">{{ $t('result.bet') + `${currency}` }}</div>
        <div class="text-subhead">{{ data.bet | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-blessingox">{{ $t('result.winlose') + `${currency}` }}</div>
        <div class="text-subhead">{{ data.winlose | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-blessingox">{{ $t('result.balance') + `${currency}` }}</div>
        <div class="text-subhead">{{ data.balance | currencyFormatter }}</div>
      </div>
    </div>
    <div class="content-result-blessingox pt-3">
      <div class="text-games-blessingox">{{ 'BLESSING OF THE OX' }}</div>
      <div class="text-subgame">{{ $t('blsox.name') }}</div>
      <div class="text-date-blessingox mb-1">{{ data.timestamp }}</div>

      <div class="col-12 justify-content-center d-flex flex-row p-0">
        <div class="table-blessingox container d-flex flex-column justify-content-center">
          <table>
            <tbody>
              <tr v-for="(row, index) in table" :key="index">
                <td v-for="(col, i) in row" :key="`${index}${i}`">
                  <img
                    :class="i === 0 ? 'icon-symbol-blessingox-left' : i === 2 ? 'icon-symbol-blessingox-right' : 'icon-symbol-blessingox'"
                    :src="require(`../../assets/resultGame/blessingox/symbol_${col}.png`)">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="data.detail.baseReelStopIndexes.length > 3" class="col-12 justify-content-center d-flex flex-row">
        <hr class="line col-3">
        <div class="text-detail align-items-center d-flex px-3">{{ $t('result.extrareel') }}</div>
        <hr class="line col-3">
      </div>

      <div v-if="data.detail.baseReelStopIndexes.length > 3" class="col-12 justify-content-center d-flex flex-row">
        <div class="extrareel-blessingox">
          <img class="icon-feature-blessingox"
            :src="require(`../../assets/resultGame/blessingox/symbol_${this.feature}.png`)">
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row">
        <hr class="line col-3">
        <div class="text-detail align-items-center d-flex px-3">{{ $t('result.detail') }}</div>
        <hr class="line col-3">
      </div>

      <div class="col-12 justify-content-center d-flex flex-row">
        <div class="bet-wrapper-blessingox item">
          <div class="d-flex mt-2 ml-2 justify-content-center">
            <p v-if="data.detail.winning !== 0" class="text-reult-blessingox mb-2">{{ $t('result.winning') }}</p>
            <p v-else class="text-reult-blessingox">{{ $t('result.nowin') }}</p>
          </div>
          <div class="d-flex justify-content-center col-12 row item p-0">
            <div class="d-flex flex-column align-items-start justify-content-center ml-4">
              <span class="">{{ $t('result.bet') }} : {{ data.bet | currencyFormatter }}</span>
            </div>
            <div class="d-flex flex-column justify-content-center ml-4 text-win">
              <span class="">{{ $t('result.win') }} : {{ data.detail.winning | currencyFormatter }} {{ currency }}</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import utils from '../../services/utils'
export default {
  name: 'result-blessingox',
  props: {
    data: Object,
  },
  data() {
    return {
      headerHeight: null,
      table: [
        [1, 2, 3]
      ],
      dateTimeFormatter: function formatter(date) { return utils.dateTimeFormatter(date) },
      tokenData: utils.getTokenData(this.$route.query.t),
      date: '',
      time: '',
      // result: this.data,
      count: this.data.count,
      countSymbol: [],
      symbolsDetail: [],
      bonusGames: false,
      symbolsBonus: [],
      currency: this.data.currency ? this.data.currency : 'THB',
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      feature: 0,
    }
  },
  async created() {
    await this.mapSymbol()
  },
  methods: {
    onResize() {
      this.headerHeight = document.getElementsByClassName('header-blessingox')[0].offsetHeight
    },
    mapSymbol() {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      this.table[0][0] = this.data.game.config.baseGameReel1[this.data.detail.baseReelStopIndexes[0]]
      this.table[0][1] = this.data.game.config.baseGameReel2[this.data.detail.baseReelStopIndexes[1]]
      this.table[0][2] = this.data.game.config.baseGameReel3[this.data.detail.baseReelStopIndexes[2]]
      if (this.data.detail.baseReelStopIndexes.length > 3) {
        this.feature = this.data.game.config.baseGameReel4[this.data.detail.baseReelStopIndexes[3]]
      }
      if (this.data.detail.isCoin) this.currency = 'AMS';
    },
  }
}
</script>

<style scoped>
.arrow {
  color: #cac095;
  text-align: center;
}

.bet-box {
  background: #0c161f;
  border-radius: 10px;
  min-height: 200px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bonus-box {
  background: #0c161f;
  border-radius: 10px;
  min-height: 150px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.text-reult-blessingox {
  font-size: 35px;
  color: #FFC468;
  text-shadow: 0px 0px 20px rgb(255, 255, 255);
}

.bet-wrapper-blessingox {
  color: #fff;
  background: #2C2014;
  line-height: 1;
  border-radius: 15px;
  border: 4px solid #FFC468;
  height: 170px;
  width: 560px;
  margin-top: 8%;
}

.bet-box .bet-wrapper-blessingox:not(:first-child) .item {
  margin-top: 10px;
}

.bet-wrapper-blessingox,
.result-wrapper {
  font-size: 35px;
}

.header-blessingox {
  background: #735527;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-blessingox>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-blessingox {
  color: #FFC468;
  text-align: center;
}

.content-result-blessingox {
  background: #2C2014;
  height: 150vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-blessingox {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-games-blessingox {
  color: #FFC468;
  font-size: 25px;
  text-align: center;
}

.text-subhead {
  font-size: px;
  color: white;
  text-align: center;
}

.text-subgame {
  font-size: 20px;
  color: white;
  text-align: center;
}

.text-date {
  font-size: 20px;
  color: #000000;
  text-align: center;
}

.text-date-blessingox {
  font-size: 20px;
  color: #FFC468;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #c7b873;
  text-align: center;
}

.icon-symbol-blessingox {
  width: 100%;
  padding-inline: 6px;
}

.icon-symbol-blessingox-left {
  width: 100%;
  padding-inline-end: 15px;
}

.icon-symbol-blessingox-right {
  width: 100%;
  padding-inline-start: 15px;
}

.bet-box {
  min-width: 600px;
  max-width: auto;
}

.table-blessingox {
  background: url('~@/assets/resultGame/blessingox/slot_frame.png') no-repeat;
  background-size: 590px 300px;
  width: 590px;
  height: 300px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
}

.extrareel-blessingox {
  background: url('~@/assets/resultGame/blessingox/extrareel_frame.png') no-repeat;
  background-size: 452px 435px;
  width: 452px;
  height: 435px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
}

.icon-feature-blessingox {
  margin-top: 180px;
  width: 30%;
  padding-inline: 6px;
}

@media screen and (max-width: 1030px) {
  .table-blessingox {
    background-size: 500px 300px;
    width: 500px;
    height: 300px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .bet-box {
    min-width: 580px;
    max-width: auto;
    height: 280px;
  }

  .bet-wrapper-blessingox,
  .result-wrapper {
    font-size: 35px;
  }
}

@media screen and (min-width: 1060px) {

  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-blessingox,
  .result-wrapper {
    font-size: 33px;
  }

}

.line {
  background-color: #c7b873;
  height: 2px;
  width: 100%;
}

.red {
  color: #ff0000;
}

.green {
  color: #10b24b;
}

@media screen and (max-width: 770px) {
  .heading-blessingox {
    font-size: 18px;
  }

  .table-blessingox {
    background-size: 470px 230px;
    width: 470px;
    height: 230;
    margin-bottom: 1%;
    padding-bottom: 30px;
  }

  .text-subhead {
    font-size: 18px;
  }

  .bet-box {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #000000;
    text-align: center;
  }

  .text-date-blessingox {
    font-size: 20px;
    color: #FFC468;
    text-align: center;
  }
}

@media screen and (max-width: 480px) {
  .header-blessingox>div {
    flex-grow: 0;
    width: 25%;
  }

  .text-win {
    margin-left: 3px;
    margin-top: 5px;
  }

  .heading-blessingox {
    font-size: 12px;
  }

  .table-blessingox {
    background-size: 270px 120px;
    width: 270px;
    height: 120px;
    padding-top: 1.6rem;
  }

  .text-subhead {
    font-size: 14px;
  }

  .bet-box {
    min-width: 230px;
    max-width: auto;
    height: 200px;
  }

  .bet-wrapper-blessingox {
    color: #fff;
    background: #2C2014;
    line-height: 1;
    border-radius: 15px;
    border: 4px solid #FFC468;
    height: 100px;
    width: 270px;
    /* margin-top: 8%; */
  }

  .text-reult-blessingox {
    font-size: 15px;
    color: #FFC468;
  }

  .bonus-box {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-blessingox,
  .result-wrapper {
    font-size: 20px;
    /* margin-bottom: ; */
  }

  .extrareel-blessingox {
    background: url('~@/assets/resultGame/blessingox/extrareel_frame.png') no-repeat;
    background-size: 181px 172px;
    width: 181px;
    height: 172px;
    border-radius: 5px;
    font-size: 30px;
    text-align: center;
  }

  .icon-feature-blessingox {
    margin-top: 65px;
    width: 40%;
    padding-inline: 6px;
  }

}
</style>
